import { Injectable } from '@angular/core';
import { EnumApiScales, EnumScales } from '@library/store/measures/measures.interface';
import { CpCompareHeaderCacheService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-header/cp-compare-header-cache.service';
import { ReplaySubject, map, shareReplay } from 'rxjs';

@Injectable()
export class CpCompareScaleService {

  scale$ = new ReplaySubject<EnumScales>(1);
  apiScale$ = this.scale$.asObservable().pipe(
    map(scale => ({
      [EnumScales.DAY]: EnumApiScales.FIVE_MINUTES,
      [EnumScales.WEEK]: EnumApiScales.THREE_HOURS,
      [EnumScales.MONTH_DAILY]: EnumApiScales.ONE_DAY,
      [EnumScales.YEAR]: EnumApiScales.ONE_WEEK,
    }[scale])),
    shareReplay(1),
  );

  setScale(scale: EnumScales) {
    this.scale$.next(scale);
    this.compareHeaderCacheService.setScale(scale);
  }

  constructor(
    private compareHeaderCacheService: CpCompareHeaderCacheService,
  ) {}

}
